import * as amplitude from '@amplitude/analytics-browser';
import { plugin as engagementPlugin } from '@amplitude/engagement-browser';
import { snowplowDUID } from 'services/TrackingService';


export default async () => {
  amplitude.init(process.env.AMPLITUDE_API_KEY, {
    fetchRemoteConfig: true,
    autocapture: true,
    deviceId: await snowplowDUID(),
  });

  amplitude.add(engagementPlugin());
};
